import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function parseFeatureFlags(search) {
  const params = new URLSearchParams(search || '');
  const flags = new Set();

  for (const [key, value] of params.entries()) {
    if (!key) continue;
    if (value !== '') continue;
    flags.add(key.toLowerCase());
  }

  return flags;
}

export function useFeatureFlag(flagName) {
  const location = useLocation();

  const potentialFlags = useMemo(() => parseFeatureFlags(location.search), [location.search]);

  if (!flagName) return false;
  return potentialFlags.has(flagName.toLowerCase());
}
